<div class="card-body p-0 create-committee-nfr">
    <div class="row">
        <div class="col-12">
            <div class="rana-page-header">
                <div>
                    <h1 class="rana-page-title">{{ chapter?.name }} &middot; Executive Committee</h1>
                    <p class="rana-page-subtitle" *ngIf="sortedCommitteeMembers.length">{{ sortedCommitteeMembers.length }} member{{ sortedCommitteeMembers.length === 1 ? '' : 's' }}</p>
                </div>
                <button type="button" class="btn btn-dark-primary" data-toggle="modal"
                        data-target="#modal-add-committee-member" (click)="addCommitteeMember()"
                        *ngIf="allChapters || (userRole?.COMMITTEE?.includes('CREATE') && (this.userChapter === this.chapterId))"
                        title="Add Committee Member">
                    <i class="uil uil-user-plus size-20"> </i> Add Member
                </button>
            </div>

            <div class="col-12 py-3">
                <div class="section divider one-dashed"></div>
            </div>

            <div class="col-xl-12" *ngIf="showCommittee">
                <div class="row">
                    <!-- Loop through ec array -->
                    <div class="col-sm-6 col-lg-4 mb-4"
                         *ngFor="let committeeMember of sortedCommitteeMembers; let i = index">
                        <div class="rana-committee-card">
                            <div class="rana-committee-actions"
                                 *ngIf="allChapters || (userRole?.COMMITTEE?.includes('CREATE') && (this.userChapter === this.chapterId))">
                                <div class="rana-committee-icon-btn"
                                     (click)="openEditModal(committeeMember.id, committeeMember.email, committeeMember.title)"
                                     title="Edit Committee Member">
                                    <i class="uil uil-edit-alt"></i>
                                </div>
                                <div class="rana-committee-icon-btn"
                                     (click)="deleteCommittee(committeeMember.id)"
                                     title="Remove Committee Member">
                                    <i class="uil uil-trash-alt"></i>
                                </div>
                            </div>

                            <img *ngIf="committeeMember.uploadedImageUrl" class="rana-committee-photo"
                                 [src]="committeeMember.uploadedImageUrl" alt=""/>
                            <div *ngIf="!committeeMember.uploadedImageUrl"
                                 class="rana-committee-avatar" [ngClass]="avatarTint(committeeMember, i)">
                                {{ memberInitials(committeeMember) }}
                            </div>

                            <div class="rana-committee-name">{{ committeeMember?.firstname }} {{ committeeMember?.lastname }}</div>
                            <div class="rana-committee-role" [ngClass]="isLeadershipRole(committeeMember.title) ? 'lead' : 'std'">
                                {{ committeeMember.title }}
                            </div>

                            <div class="rana-committee-divider"></div>

                            <div class="rana-committee-contact">
                                <div class="rana-committee-contact-row" [class.muted]="!committeeMember?.phone">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
                                    <a *ngIf="committeeMember?.phone" [href]="'tel:' + committeeMember.phone">{{ committeeMember.phone }}</a>
                                    <span *ngIf="!committeeMember?.phone">No phone on file</span>
                                </div>
                                <div class="rana-committee-contact-row" [class.muted]="!committeeMember?.email">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 6 10-6"/></svg>
                                    <a *ngIf="committeeMember?.email" [href]="'mailto:' + committeeMember.email">{{ committeeMember.email }}</a>
                                    <span *ngIf="!committeeMember?.email">No email on file</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>


<div class="modal fade" id="editCommitteeModal" tabindex="-1" role="dialog" aria-labelledby="editCommitteeModalLabel"
     aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <div class="container-fluid">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                        <i class="uil uil-multiply"></i>
                    </button>
                    <div class="row justify-content-center">
                        <div class="col-12 text-center">
                            <h5 class="mb-3">Edit Committee Member</h5>
                        </div>
                        <div class="col-12">
                            <form [formGroup]="memberForm" class="nfr-form-standard">

                                <div class="form-group mt-4">
                                    <!--input type="text" formControlName="role"
                                      class="form-style big form-style-with-icon section-shadow-blue" placeholder="Member Role"
                                      autocomplete="off" /-->

                                    <select formControlName="role"
                                            class="form-style big form-style-with-icon section-shadow-blue">
                                        <option value="">Select Role</option>
                                        <option *ngFor="let r of commiteeroles" [value]="r.role">{{ r.role }}</option>
                                    </select>
                                    <i class="input-icon big uil uil-briefcase-alt"></i>
                                    <small *ngIf="memberForm.get('role')?.invalid && memberForm.get('role')?.touched"
                                           class="text-danger">
                                        Role is required.
                                    </small>
                                </div>

                                <div class="form-group mt-4" style="position: relative;">
                                    <input
                                            type="email"
                                            formControlName="email"
                                            class="form-style big form-style-with-icon section-shadow-blue"
                                            placeholder="Email"
                                            autocomplete="off"
                                            (input)="onEmailInput()"
                                            (focus)="showUserDropdown = true"
                                            (blur)="hideDropdownWithDelay()"
                                    />
                                    <i class="input-icon big uil uil-envelope"></i>
                                    <small *ngIf="memberForm.get('email')?.invalid && memberForm.get('email')?.touched"
                                           class="text-danger">
                                        Valid email is required.
                                    </small>

                                    <!-- Autocomplete dropdown -->
                                    <ul *ngIf="showUserDropdown && filteredUsers.length > 0"
                                        class="autocomplete-dropdown"
                                        style="position: absolute; z-index: 10; background: #fff; width: 100%; border: 1px solid #ccc; max-height: 200px; overflow-y: auto;">
                                        <li *ngFor="let user of filteredUsers"
                                            (mousedown)="selectUser(user)"
                                            style="padding: 8px; cursor: pointer;">
                                            {{ user.firstname }} {{ user.lastname }} ({{ user.email }})
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-12 text-center mt-5">
                                    <button type="submit" class="btn btn-dark-primary" (click)="updateCommittee()"
                                            [disabled]="memberForm.invalid">
                                        Update Member
                                        <i class="uil uil-plus-circle size-22 ml-3"></i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal fade modal-small" id="modal-add-committee-member" tabindex="-1" role="dialog"
     aria-labelledby="modal-add-member" aria-hidden="true">
    <div class="modal-dialog" role="document">

        <div class="modal-content section-background-13">
            <div class="modal-body z-bigger">
                <div class="container-fluid">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="uil uil-multiply"></i>
                    </button>
                    <div class="row justify-content-center">
                        <div class="col-12 text-center">
                            <h5 class="mb-3">Add Committee Member</h5>
                        </div>
                        <div class="col-12">
                            <form [formGroup]="memberForm" class="nfr-form-standard">

                                <div class="form-group mt-4">
                                    <!--input type="text" formControlName="role"
                                      class="form-style big form-style-with-icon section-shadow-blue" placeholder="Member Role"
                                      autocomplete="off" /-->

                                    <select formControlName="role"
                                            class="form-style big form-style-with-icon section-shadow-blue">
                                        <option value="">Select Role</option>
                                        <option *ngFor="let r of commiteeroles" [value]="r.role">{{ r.role }}</option>
                                    </select>
                                    <i class="input-icon big uil uil-briefcase-alt"></i>
                                    <small *ngIf="memberForm.get('role')?.invalid && memberForm.get('role')?.touched"
                                           class="text-danger">
                                        Role is required.
                                    </small>
                                </div>

                                <!--div class="form-group mt-4">
                                  <input type="email" formControlName="email"
                                    class="form-style big form-style-with-icon section-shadow-blue" placeholder="Email"
                                    autocomplete="off" />
                                  <i class="input-icon big uil uil-envelope"></i>
                                  <small *ngIf="memberForm.get('email')?.invalid && memberForm.get('email')?.touched"
                                    class="text-danger">
                                    Valid email is required.
                                  </small>
                                </div-->
                                <div class="form-group mt-4" style="position: relative;">
                                    <input
                                            type="email"
                                            formControlName="email"
                                            class="form-style big form-style-with-icon section-shadow-blue"
                                            placeholder="Email"
                                            autocomplete="off"
                                            (input)="onEmailInput()"
                                            (focus)="showUserDropdown = true"
                                            (blur)="hideDropdownWithDelay()"
                                    />
                                    <i class="input-icon big uil uil-envelope"></i>
                                    <small *ngIf="memberForm.get('email')?.invalid && memberForm.get('email')?.touched"
                                           class="text-danger">
                                        Valid email is required.
                                    </small>

                                    <!-- Autocomplete dropdown -->
                                    <ul *ngIf="showUserDropdown && filteredUsers.length > 0"
                                        class="autocomplete-dropdown"
                                        style="position: absolute; z-index: 10; background: #fff; width: 100%; border: 1px solid #ccc; max-height: 200px; overflow-y: auto;">
                                        <li *ngFor="let user of filteredUsers"
                                            (mousedown)="selectUser(user)"
                                            style="padding: 8px; cursor: pointer;">
                                            {{ user.firstname }} {{ user.lastname }} ({{ user.email }})
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-12 text-center mt-5">
                                    <button type="submit" class="btn btn-dark-primary" (click)="addCommittee()"
                                            [disabled]="memberForm.invalid">
                                        Add Member
                                        <i class="uil uil-plus-circle size-22 ml-3"></i>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
